import { Outlet } from 'react-router-dom';
import { PrelineLoader } from './PrelineLoader';
import { ErrorBoundary } from '../components/ErrorBoundary';

/**
 * Public Layout for routes that don't require authentication
 *
 * Provides:
 * - Preline UI loader
 * - Error boundary for public pages
 * - Simple wrapper for public pages
 */
export function PublicLayout() {
  return (
    <>
      <PrelineLoader />
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
    </>
  );
}
